import { render, staticRenderFns } from "./Legal_pay.vue?vue&type=template&id=471108da&scoped=true"
import script from "./Legal_pay.vue?vue&type=script&lang=js"
export * from "./Legal_pay.vue?vue&type=script&lang=js"
import style0 from "./Legal_pay.vue?vue&type=style&index=0&id=471108da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471108da",
  null
  
)

export default component.exports